import React from "react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const euros = (v) => Number(v).toLocaleString("fr-FR");
export const CupraConditionsPanel = ({ model, form, onChange }) => {
  const plan = model.cupra_conditions;
  const company = form.company_type !== "NON";
  const vd = form.is_vd_sale || form.is_vdr_sale;
  const context = form.cupra_context || {};
  const trade = context.trade_in_type || "NONE";
  const setContext = (field, value) => onChange("cupra_context", { ...context, [field]: value });
  const rate = model.company_rates?.[form.company_type];
  const dates = vd ? [["registration_date", "Date d’immatriculation VD/VDR", plan.order_from, plan.order_until]] : trade !== "NONE" ? [
    ["order_date", "Date de commande", plan.trade_order_from, plan.trade_order_until],
    ["aak_date", "Date AAK", plan.trade_aak_from, plan.trade_aak_until],
  ] : [];
  return (
    <section data-testid="cupra-conditions-panel" className="mt-4 space-y-3 border-t pt-4">
      <h3 data-testid="cupra-conditions-title" className="text-sm font-semibold">CUPRA · {plan.period}</h3>
      {company ? <p data-testid="cupra-company-rule" className="text-sm">
        {!plan.company_eligible ? "Finition exclue de la grille sociétés." : ["PSTE_RY", "PROTOCOLE_GC"].includes(form.company_type) ? "Taux total sur accord, base incluse." : rate === undefined ? "Catégorie non renseignée." : <>
          Marge totale : {euros(rate * 100)} % · Base incluse. Remise préconisée : {euros(plan.recommended_discounts[form.company_type] * 100)} %.
          {form.company_type === "PSTER" && plan.pster_reinforcement_required && " Renfort sur accord, non chiffré dans cette grille."}
        </>}
      </p> : <>
        {!vd && <div className="flex items-center justify-between gap-3">
          <label htmlFor="cupra-deal" data-testid="cupra-deal-label" className="text-sm font-medium">Vente DEAL{plan.deal_rate != null ? ` · ${euros(plan.deal_rate * 100)} % au total` : " · non renseignée"}</label>
          <Switch id="cupra-deal" data-testid="cupra-deal-switch" checked={form.is_deal_sale} disabled={plan.deal_rate == null} onCheckedChange={(v) => onChange("is_deal_sale", v)} />
        </div>}
        <p data-testid="cupra-sale-rule" className="text-sm text-muted-foreground">
          {form.is_deal_sale ? "Marge totale sur facture, sans ajout de base, prime systématique ou reprise." : vd ?
            `Base + prime du mois d’immatriculation${model.vd_rate > 0 ? ` + ${form.is_vd_sale ? 3 : 4} %` : ""}.` :
            plan.private_grid_verified ? `Offre client de référence : ${euros(plan.private_offer_ttc)} € TTC · Participation réseau : ${euros(plan.network_participation_ht)} € HT · Marge restante indicative : ${euros(plan.minimum_margin_rate * 100)} %.` : "Finition non détaillée en particuliers : conditions antérieures conservées."}
        </p>
        {!form.is_deal_sale && !vd && model.trade_in_bonus > 0 && <>
          <label id="cupra-trade-label" data-testid="cupra-trade-label" className="text-sm font-medium">Aide reprise Raval</label>
          <Select value={trade} onValueChange={(v) => setContext("trade_in_type", v)}>
            <SelectTrigger data-testid="cupra-trade-select" aria-labelledby="cupra-trade-label"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="NONE" data-testid="cupra-trade-none-option">Aucune aide reprise</SelectItem>
              <SelectItem value="ALL" data-testid="cupra-trade-all-option">Toutes marques · {euros(model.trade_in_bonus)} € HT</SelectItem>
              <SelectItem value="MINI" data-testid="cupra-trade-mini-option">Mini · {euros(model.reprise_mini_bonus)} € HT</SelectItem>
            </SelectContent>
          </Select>
          <p data-testid="cupra-trade-rule" className="text-xs text-muted-foreground">Aides exclusives. PO du 01/10 au 31/10/2026 ; AAK du 01/10/2026 au 31/03/2027. Particuliers hors DEAL et VD/VDR.</p>
        </>}
        {dates.length > 0 && <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">{dates.map(([key, label, min, max]) => (
          <div key={key} className="space-y-1 min-w-0">
            <label htmlFor={`cupra-${key}`} data-testid={`cupra-${key.replaceAll("_", "-")}-label`} className="text-sm">{label}</label>
            <Input type="date" id={`cupra-${key}`} data-testid={`cupra-${key.replaceAll("_", "-")}-input`} min={min} max={max} className="min-w-0 max-w-full"
              value={context[key] || ""} onChange={(e) => setContext(key, e.target.value)} />
          </div>
        ))}</div>}
      </>}
    </section>
  );
};